import { Component, OnInit } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-people-widget',
    templateUrl: './people-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './people-widget.component.scss'],
    standalone: false
})
export class PeopleWidgetComponent extends BaseWidgetComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
